import type { FlowScreenConfig } from "@/shared/constants/flowTypes";

import { SafeDepositReview } from "../components/SafeDepositReview";
import { AddSafeDeposit } from "../components/AddSafeDeposit";
import { createModuleComplete } from "@/pages/postloss/modules/components/ModuleComplete";

export function createDepositBoxesScreens(firstName: string): FlowScreenConfig[] {
  return [
    {
      id: "safe_deposit_step",
      layout: "full",
      maxWidth: "2xl",
      hideButton: true,
      customComponent: SafeDepositReview,
      shouldDisplay: ({ answers }) => answers["safe_deposit_review"] !== "none",
    },
    {
      id: "has_safe_deposit",
      layout: "full",
      textAlign: "center",
      maxWidth: "2xl",
      title: `Did ${firstName} have a safety deposit box?`,
      subtitle: "This includes bank safe deposit boxes or home safes.",
      question: {
        type: "multiple_choice",
        required: true,
        options: [
          { value: "yes", label: "Yes, they had a safety deposit box or safe" },
          { value: "no", label: "No safety deposit box or safe" },
          { value: "not_sure", label: "Not sure" },
        ],
      },
      shouldDisplay: ({ answers }) => answers["safe_deposit_review"] === "none",
    },
    {
      id: "add_safe_deposit",
      layout: "full",
      maxWidth: "4xl",
      hideButton: true,
      skipOnBack: true,
      customComponent: AddSafeDeposit,
      shouldDisplay: ({ answers }) =>
        answers["has_safe_deposit"] === "yes" && answers["safe_deposit_review"] !== "has_items",
    },
    {
      id: "final_screen",
      layout: "full",
      textAlign: "center",
      hideButton: true,
      headerTitle: "",
      customComponent: createModuleComplete(),
    },
  ];
}
